module.exports = __webpack_public_path__ + "img/zuk.fdb32721.svg";